class ProductCardJS {
  constructor(target) {
    this.target = target;
    this._isLoaded = false;
  }
  connectedCallback() {
    // this._renderProductCard();
  }
  async _renderProductCard() {
    if (this._isLoaded) {
      return;
    }
    return `
    
    `;
  }
  async _fetchProductCard(handle = "testeverde-escuro-prato-oval-riviera") {
    if (!handle) {
      return ``;
    }

    const url = `/products/${handle}?view=card`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "User-Agent": navigator.userAgent, // optional, usually ignored by browsers
          Accept: "text/html",
        },
      });

      if (!response.ok) {
        debugger;
        return ``;
        // throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Get inner content of the wrapper div
      const sectionWrapper = doc.querySelector(".shopify-section");
      const innerHTML = sectionWrapper ? sectionWrapper.innerHTML : htmlString;
      return innerHTML;
    } catch (error) {
      console.error("Fetch error:", error);
      debugger;
      return ``;
    }
  }
}
